// @ts-nocheck

/**
 * * `left` - left
 * `center` - center
 * `right` - right
 */
export type AlignEnum = typeof AlignEnum[keyof typeof AlignEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlignEnum = {
  left: "left",
  center: "center",
  right: "right",
} as const;
